export const ONE_SECOND = 1000;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = 24 * ONE_HOUR;
export const ONE_MONTH = 30 * ONE_DAY;

export const FORMAT_DATE = "dd.MM.yyyy";
export const FORMAT_DATE_IN_FORM = "yyyy-MM-dd";
export const FORMAT_DATE_WITH_TIME = "dd.MM.yyyy, HH:mm";
export const FORMAT_TIME = 'HH:mm';
